import { useQuery } from "react-query";
import { getOnLeaveFranchiseEmployeeCount } from "../../../../../actions/Employees";

const useGetOnLeaveFranchiseEmployeeCount = () => {
  return useQuery(
    "GetOnLeaveFranchiseEmployeeCount",
    getOnLeaveFranchiseEmployeeCount,
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetOnLeaveFranchiseEmployeeCount;
